<template>
  <div id="app">
    <app-header></app-header>
    <app-body></app-body>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Body from "./components/Body.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    "app-header": Header,
    "app-body": Body,
    "app-footer": Footer
  }
};
</script>

<style lang="scss">
// @import url('https://fonts.googleapis.com/css?family=PT+Sans:400,700&subset=cyrillic');
@import "~styles/_vars.scss";

@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  src: url('../static/fonts/PT_Sans-regular.woff2') format('woff2'),
  url('../static/fonts/PT_Sans-regular.woff') format('woff');
}

@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 700;
  src: url('../static/fonts/PT_Sans-bold.woff2') format('woff2'),
  url('../static/fonts/PT_Sans-bold.woff') format('woff');
}

/* DEFAULTS */

body {
  box-sizing: border-box;
  font-size: 16px;
  color: $black;
  font-family: 'PT Sans', sans-serif;
  overflow-x: hidden;
}

*, *:before, *:after {
  box-sizing: inherit;
}

body, h1, h2, h3, h4, h5, h6, p, ol, ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ol, ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

a {
  color: inherit;
  text-decoration: none;
}

::selection {
  color: white;
  background: $dark;
}



/* FLEX GRID */

#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: url('~images/background.jpg');
  background-size: 2.5rem;
}

.app-body {
  margin: 0 11vw;
  padding: 3rem 0 4rem;
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  transition: margin .35s;
  overflow: hidden;

  @media screen and (max-width: $desktop-medium) {
    margin: 0 6vw;
    padding: 2rem 0 4rem;
  }

  @media screen and (max-width: $desktop-small) {
    margin: 0 2vw;
    padding: 1rem 0 2rem;
    flex-direction: column;
  }
}

.body-content {
  flex: 1;
  padding: 0 1.5vw;
  margin: 0;

  @media screen and (max-width: $desktop-small) {
    flex: initial;
    padding: 0;
  }
}

.sidebar-left,
.sidebar-right {
  flex: 0 0 $sidebar-width;
  display: block;

  @media screen and (max-width: $desktop-small) {
    display: none;
  }
}



/* ROUTER TRANSITION */

.view {
  backface-visibility: hidden;
  z-index: 1;
}

.view-enter-to, .view-leave {
  opacity: 1;
  transform: translate(0);
}

.view-leave-to {
  opacity: 0;
  transform: translateX(-1vw);

  @media screen and (max-width: $desktop-small) {
    transform: translateY(1vw);
  }
}

.view-enter {
  opacity: 0;
  transform: translateX(1vw);

  @media screen and (max-width: $desktop-small) {
    transform: translateY(-1vw);
  }
}

.view-enter-active {
  transition: all .35s ease;
}

.view-leave-active {
  transition: all .35s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
</style>



// WEBPACK FOOTER //
// client/App.vue